"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.giftAid = exports.donationConfig = exports.amount = exports.DonationDefinition = void 0;

var _types = require("../../types");

var _config = require("../config");

var _fieldDefinitionTypes = require("../../fields/config/fieldDefinitionTypes");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var CurrencyFieldDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.CurrencyFieldDefinition;
});

var CheckboxDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.CheckboxDefinition;
});

var ComponentConfigDefinition = _flowRuntime["default"].tdz(function () {
  return _config.ComponentConfigDefinition;
});

var ComponentElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.ComponentElementDefinition;
});

var amount = {
  key: 'amount',
  label: 'Amount',
  type: 'currency',
  ui: {
    classes: 'col span_6_of_12 push_3'
  },
  validation: [{
    required: true
  }, {
    currency: true
  }]
};
exports.amount = amount;
var giftAid = {
  key: 'giftaid',
  type: 'checkbox',
  items: [{
    key: 'giftaidCheckbox',
    label: 'Yes, I am a UK tax payer and would like to boost my donations by 25p for every £1 I donate'
  }],
  description: 'By checking the box I confirm Anthony Nolan will claim Gift Aid from the tax I pay for the corresponding tax year. My address is needed to identify me as a current UK taxpayer. I want to Gift Aid my donation and any donations I make from the date of this declaration or have made in the past 4 years to Anthony Nolan. I am a UK taxpayer and understand that if I pay less Income Tax and/or Capital Gains Tax than the amount of Gift Aid claimed on all my donations in that tax year, it is my responsibility to pay any difference.',
  label: 'Make your gift worth 25% more (at no extra cost to you!):',
  ui: {
    classes: 'large',
    descriptionPosition: 'after'
  },
  validation: []
}; // eslint-disable-next-line import/prefer-default-export

exports.giftAid = giftAid;
var donationConfig = {
  type: 'donation',
  fields: [giftAid, amount]
};
exports.donationConfig = donationConfig;

var DonationDefinition = _flowRuntime["default"].type("DonationDefinition", _flowRuntime["default"].spread(_flowRuntime["default"].ref(ComponentElementDefinition), _flowRuntime["default"].object(_flowRuntime["default"].property("type", _flowRuntime["default"].string("donation")))));

exports.DonationDefinition = DonationDefinition;